<svg style="width:0;height:0;position:absolute;top:-1px;overflow:hidden;">
    <defs>  
        <g id="loading-spinner">  
            <circle 
            fill="none" 
            stroke="#666" 
            stroke-width="8" cx="50" cy="50" r="48" 
            stroke-dasharray="270" 
            stroke-linecap="round" 
            stroke-dashoffset="40"
            transform="rotate(-90 ) translate(-100 0)" >                   
            </circle>
        </g>  
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" id="performance-arrow-down--s"><path d="M7.589 11.831l-4.38-3.963 1.069-1.12L6.9 9.143l-.073-.417V2.771h1.53v5.954l-.057.418 2.607-2.4 1.083 1.125z"/></symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" id="performance-arrow-up--s"><path d="M7.516 2.785L11.9 6.748l-1.062 1.12L8.2 5.466l.081.425v5.955H6.754V5.891l.059-.425-2.607 2.4-1.085-1.118z"/></symbol>
      </defs>    
    
</svg>

<div class="buttons">
    <div class="rowW">
        <div class="buttonW tl">Return Type:</div>
        <div class="buttonW pointer" [ngClass]="{'active':(returnType=='Total Return')}" (click)="returnType='Total Return'">Total Return (TR)</div>
        <div class="buttonW pointer tr" [ngClass]="{'active':(returnType=='Price Return')}" (click)="returnType='Price Return'">Price Return (PR)</div>
    </div>
    <div class="rowW">
        <div class="buttonW pointer bl" [ngClass]="{'active':(groupIndex==0)}" (click)="groupIndex=0">U.S.</div>    
        <div class="buttonW pointer br" [ngClass]="{'active':(groupIndex==1)}" (click)="groupIndex=1">Globals</div>
    </div>
</div>

<table class="table table-sm table-hover table-responsive">
   <tbody>
    <ng-container *ngFor="let tab of tabs; let idx = index">
        <ng-container *ngFor="let i of tab.investments" [ngClass]="">
            <tr *ngIf="groupIndex==idx && i.type==returnType">               
                <td><span [innerHTML]="i.name|safe:'html'"></span><span *ngIf="i.type=='Total Return'; else priceReturn"> TR</span><ng-template #priceReturn> PR</ng-template></td>
                <td class="text-end">{{(i.endingValue?(i.endingValue|number:'1.2-2'):'N/A')}}</td>
                <td class="text-end" [ngClass]="i.className"><svg class='arw' *ngIf="i._points;"><use [attr.xlink:href]="i.useID"></use></svg>{{(i._points?(i._points|number:'1.2-2'):"N/A")}}</td>
                <td class="text-end" [ngClass]="i.className">{{i._percent?i._percent:"N/A"}}<span *ngIf="i._percent">%</span></td>
            </tr>
        </ng-container>
    </ng-container>
   </tbody>
</table>
<div class="d-flex justify-content-between px-1">
    <span class="msDate">{{latestCommonDate|date:'M/d/yyyy':'UTC'}}</span>
    <div class="btn btn-link msDate p-0 border-0" data-bs-toggle="modal" data-bs-target="#tickerDisclosuresModalMorningstarTotalAndPriceReturnsWidget">Disclosures</div>
</div>

